import { useState, useEffect } from "react";

/**
 * Tracks the on-screen keyboard height via the VisualViewport API.
 * Returns 0 when the keyboard is hidden.
 * Works on iOS Safari, Android WebView and Capacitor without any native plugin.
 */
export function useKeyboardHeight(): number {
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    const vp = window.visualViewport;
    if (!vp) return;

    const update = () => {
      const kbHeight = window.innerHeight - vp.height - vp.offsetTop;
      setKeyboardHeight(Math.max(0, kbHeight));
    };

    vp.addEventListener("resize", update);
    vp.addEventListener("scroll", update);
    return () => {
      vp.removeEventListener("resize", update);
      vp.removeEventListener("scroll", update);
    };
  }, []);

  return keyboardHeight;
}
